import React from "react";
import { Text } from "@ui-kitten/components";
import { doc, onSnapshot } from "firebase/firestore";
import { StyleSheet, View } from "react-native";
import useDb from "../../../hooks/useDb";
import useAuth from "../../../hooks/useAuth";
import logError from "../../../helpers/logError";

const AvailableLicenses: React.FC = () => {
    const db = useDb();
    const { user } = useAuth();
    const [tokens, setTokens] = React.useState(0);

    React.useEffect(() => {
        if (user == null) {
            logError("User not exist");
            return () => {};
        }
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const unsub = onSnapshot(doc(db, "userInfo", user.uid), (doc) => {
            // TODO fix type
            // https://medium.com/swlh/using-firestore-with-typescript-65bd2a602945
            const data = doc.data() as { tokens: number } | undefined;

            if (data === undefined) {
                return;
            }
            setTokens(data.tokens);
        });
        return () => unsub();
    }, [db, user]);

    if (tokens <= 0) {
        return null;
    }

    return (
        <View style={styles.text}>
            <Text category="h3">Dostępne licencję {tokens}</Text>
        </View>
    );
};

const styles = StyleSheet.create({
    text: {
        marginBottom: 10,
    },
});

export default AvailableLicenses;
